import { useCallback, useEffect, useRef, useState } from "react";
import { getAdminCommunityStats } from "../../services/membersAdminService";
import { CommunityFormEnum } from "../../pages/community/enums/CommunityFormEnum";


interface Stats {
    accepted: number;
    declined: number;
    totalRequests: number;
    unanswered: number;
    banned: number;
}

export const useCommunityMemeberStats = (userId: number, section: CommunityFormEnum, reloadKey?: number) => {
    const isMountedRef = useRef(true);
    const [loading, setLoading] = useState(false);
    const [stats, setStats] = useState<Stats | null>(null);

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        }
    }, []);

    const load = useCallback(async () => {
        if(!userId)
            return;
        try {
            setLoading(true);
            const _stats = await getAdminCommunityStats(userId, section === CommunityFormEnum.MASTERMIND_CIRCLE ? 'circle': 'forum');
                
            if(!isMountedRef.current)
                return;

            if(!!_stats)
                setStats(_stats);
        }
        finally {
            if(!isMountedRef.current)
                return;
            setLoading(false);
        }
    }, [userId, section, reloadKey]);

    useEffect(() => {
        load();
    }, [load]);

    return { 
        loading, 
        stats
    }
}